import apiClient from './axiosInstanceStock'

export const getStock = async (id) => {
  return await apiClient.get(`/v1/cartStocks/${id}`)
}
